import events from './events/events';

/**
 * Asynchronously load view (webpack lazy loading)
 */
const loadComponent = (path, route) =>
{
    return resolve => import(path + '.vue').then(module => resolve(module)).catch(e => {

        // if error is not 404, it might be runtime error...
        console.info(e);

        if (process.env.NODE_ENV === 'production') {
            events.$emit('app.updated', route);
        } else {
            console.error(e);
        }
    });
}

export {
    loadComponent
}



// WEBPACK FOOTER //
// ./src/js/services.js